export default "__VITE_ASSET__af4623b5__"